import { Spacing } from '@vkontakte/vkui';
import React, { type VFC } from 'react';
import type { BaseSubscriptionType } from 'reactApp/modules/billingData/billingData.types';

import { CommonInfo } from '../CommonInfo/CommonInfo';

export const BaseSubscription: VFC<{ subscription: BaseSubscriptionType; isRebrandingQuotaLanding?: boolean }> = ({
    subscription: { space },
    isRebrandingQuotaLanding,
}) => (
    <>
        <CommonInfo space={space} isBase isRebrandingQuotaLanding={isRebrandingQuotaLanding} />
        <Spacing size={44} />
    </>
);
